import { render, staticRenderFns } from "./PagesSummaryTable.vue?vue&type=template&id=fd135426&"
import script from "./PagesSummaryTable.vue?vue&type=script&lang=js&"
export * from "./PagesSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports